import { render, staticRenderFns } from "./ConversationAttendance.vue?vue&type=template&id=bb9edf78&scoped=true"
import script from "./ConversationAttendance.vue?vue&type=script&lang=js"
export * from "./ConversationAttendance.vue?vue&type=script&lang=js"
import style0 from "./ConversationAttendance.vue?vue&type=style&index=0&id=bb9edf78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9edf78",
  null
  
)

export default component.exports